<template>
  <div class="w-100">
    <auto-carrier-matches v-if="flowType !== 'bundle' && flowType !== 'cabundle' && flowType !== 'rabundle'"></auto-carrier-matches>
    <bundle-carrier-matches v-else></bundle-carrier-matches>
  </div>
</template>

<script>
import AutoCarrierMatches from '@/components/interview/Auto/RC1/CarrierMatches';
import BundleCarrierMatches from '@/components/interview/shared/CarrierMatches';
/* eslint-disable */

export default {
  data() {
    return {
      flowType: ''
    };
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
  },
  components: {
    AutoCarrierMatches,
    BundleCarrierMatches
  },
};
</script>


// WEBPACK FOOTER //
// src/components/interview/Auto/RC1/Listing.vue?4ce99787